import React  from 'react'
import { Calendar, momentLocalizer } from 'react-big-calendar'
import moment from 'moment'
//import styles from "react-big-calendar/lib/css/react-big-calendar.css"
import "react-big-calendar/lib/css/react-big-calendar.css";

const localizer = momentLocalizer(moment)

const CalenderItems = props => {

    
    let {eventSelect, select, allEvents, isLogged} = props;
    
    let calViews = {
        day: true,  
        work_week: true
    }
    if (isLogged) {
        calViews = {
            month: true, 
            day: true, 
            agenda: true, 
            work_week: true
        }
    }
    console.log("props")
    console.log(calViews);

    // TRANSLATE NAMES
    const messages = {
        allDay: 'Ves dan',
        previous: '<',
        next: '>',
        today: 'Danes',
        month: 'Mesec',
        week: 'Teden',
        day: 'Dan',
        agenda: 'Agenda',
        date: 'Datum',
        time: 'Čas',
        event: 'Event',
        work_week: "Delovnik",
        showMore: total => `+ Dodatni dogodki (${total})`
    }

    let format = {
        timeGutterFormat: 'HH:mm',
        eventTimeRangeFormat: ({ // chcek after events work
            start,
            end
          }, culture, local) =>
          local.format(start, 'HH:mm', culture) + '-' +
          local.format(end, 'HH:mm', culture),
    }

    return (
        <React.Fragment>
            {allEvents !== undefined && <Calendar
                formats={format}
                messages={messages}
                selectable //={true}
                //Views={'month'|'day'}
                defaultView={"work_week"}
                views={calViews}
                localizer={localizer}
                defaultDate={new Date()}
                events={allEvents}
                style={{ height: "100vh", width: "100vw" }}
                step={15} //every 15 min ?
                timeslots={4} //per hour ?
                onSelectEvent={eventSelect}
                onSelectSlot={select}
                min={new Date(0, 0, 0, 8, 0, 0)} //day hours
                max={new Date(0, 0, 0, 16, 0, 0)}
                longPressThreshold={10} // how long to hold the press MILISEC !!! IMPORTANT
                draggableAccessor={event => false} // if Drag and drop implemented
                //onSelecting = {slot => true} if u can click and get event
                // eventPropGetter={ //getting events and style ?!?! and other things
                //     (event, start, end, isSelected) => {
                //         let newStyle = {
                //             backgroundColor: "#0289b9",
                //             color: '#fff',
                //             borderRadius: "10px",
                //             border: "none",
                //             minWidth: "100%",
                //             paddingLeft: "10px",
                //         };
                //         if (event.title === "Zasedeno") {
                //             newStyle = {
                //                 backgroundColor: "#c0e3ef",
                //                 color: '#fff',
                //                 borderRadius: "10px",
                //                 border: "none",
                //                 minWidth: "100%",
                //                 paddingLeft: "10px",
                //             }
                //         }
                //         return {
                //             className: "",
                //             style: newStyle
                //         };
                //     }
                // }
            />}
        </React.Fragment>
    )
}

export default CalenderItems;